module.exports = __webpack_public_path__ + "static/media/Drew_Griess.21c8994c.jpg";